<template>
    <div class="coupon">
        <template v-if="is_logged_in">
            <g-loading v-show="status.is_loading" :full_view="false"></g-loading>
            <div v-show="!status.is_loading" class="coupon-box" :class="{ selected: coupon_code, 'cursor-pointer': isValidCoupon}" @click="openList">
                <span class="u-text-ellipsis">
                    <template v-if="!isValidCoupon">クーポンがありません</template>
                    <template v-else-if="coupon_code">{{ getSelectedCouponName(coupon_code) }}</template>
                    <template v-else>選択してください</template>
                </span>
                <span class="c-icon" :class="{'is-stroke-right': isValidCoupon}"></span>
            </div>
            <div v-if="status.is_open">
                <div class="price-radio-box justify-center no-top-border">
                    <input :id="'coupon_unselected' + index"
                        class="custom-radio"
                        :name="'coupon_radio'+index"
                        type="radio"
                        :value="null"
                        v-model="coupon_code" />
                    <label :for="'coupon_unselected' + index">クーポン解除</label>
                </div>
                <div v-for="coupon, coupon_index in validCoupons" class="price-radio-box">
                    <input :id="'coupon_selected' + index + '_' + coupon_index"
                        class="custom-radio"
                        :name="'coupon_radio'+index"
                        type="radio"
                        :value="coupon.activate_code"
                        v-model="coupon_code" />
                    <label :for="'coupon_selected' + index + '_' + coupon_index">
                        <div class="coupon-title u-mt-1">{{ coupon.COUPON_NAME }}</div>
                        <p class="coupon-detail">種別：{{ coupon.discount_value }}OFF</p>
                        <p class="coupon-detail">クーポンコード：{{ coupon.activate_code }}</p>
                        <p class="coupon-detail" v-show="coupon.dsp_usage_end_date">有効期限：{{ coupon.dsp_usage_end_date }}まで有効</p>
                    </label>
                </div>
            </div>
        </template>
        <a v-else class="c-round-btn" @click="redirectLogin">ログインしてクーポンを見る</a>
    </div>
</template>

<script>
import routeMixin from '../../mixins/route.js';

export default {
    mixins: [routeMixin],
    props: [
        'route_list',
        'user_data',
        'user_coupon_list',
        'coupon_list',
        'selected_code',
        'item_hash',
        'index',
        'status',
        'is_logged_in',
    ],
    emits: [
        'change_coupon_code',
        'changeCoupon',
        'openList',
    ],
    model: {
        prop: 'selected_code', // 親コンポーネントから渡されるプロパティの名前
        event: 'change_coupon_code' // 子コンポーネントから親コンポーネントにイベントを発行する際の名前
    },
    computed: {
        coupon_code: {
            get() {
                return this.selected_code;
            },
            set(newValue) {
                this.$emit('change_coupon_code', newValue); // v-modelを通じて親に新しい値を送信
                this.$emit('changeCoupon', this.item_hash, newValue, this.index)
            }
        },
        isValidCoupon: function() {
            let is_valid = false
            if(!this.is_logged_in) {
                return true;
            }
            this.user_coupon_list.forEach(val => {
                if (val.filter_map[this.item_hash] === false) {
                    is_valid = true
                }
            })
            return is_valid
        },
        validCoupons: function() {
            return this.user_coupon_list.filter(coupon => {
                return coupon.filter_map[this.item_hash] === false
            })
        }
    },
    created() {
        // ユーザーのカート取得
    },
    methods: {
        openList: function() {
            if(this.validCoupons.length > 0) {
                this.$emit('openList', this.index)
            }
            if(!this.is_logged_in) {
                this.$emit('openList', this.index)
            }
        },
        getSelectedCouponName: function(coupon_code) {
            let coupon_name = "選択して下さい";
            this.user_coupon_list.forEach(function(value) {
                if (value.activate_code === coupon_code) {
                    coupon_name = value.COUPON_NAME
                }
            })
            return coupon_name;
        },
        redirectLogin: function () {
            let current_url = window.location.pathname;
            let url = this.route(this.route_list, 'site.signin', { 'backUrl': current_url });
            window.location.href = url;
        },
    }
}
</script>

<style lang="scss" scoped>
.coupon-box {
    border: 1px solid var(--gj-border-color);
    background: var(--gj-bg-color);
    color:  #566C7B;
    font-size: 13px;
    font-weight: 300;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4px 0 6px;
    &.cursor-pointer {
        cursor: pointer;
    }

    @media (min-width: 768px) {
        background: #F9F9F9;
        font-size: 11px;
    }

    &.selected {
         color: var(--gj-text-color);
    }

    .c-icon.is-stroke-right {
        transform: rotate(90deg);
        transition: transform 0.2s;

        &.open {
            transform: rotate(-90deg);
        }
    }

    &.selected {
        color: var(--gj-text-color);

        .c-icon.is-coupon {
            color: var(--gj-color-blue);
        }
    }
}

.price-radio-box {
    padding: 16px 15px;
    border: 1px solid var(--gj-border-color);
    display: flex;
    gap: 8px;

    &:not(:first-child) {
        border-top: none;
    }

    &.no-top-border {
        border-top: none;
    }

    .custom-radio {
        flex: 0 0 auto;
        appearance: none;
        border: 1px solid #b7c5cb;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        position: relative;
        opacity: 1;
        cursor: pointer;
        pointer-events: unset;

        &:checked {
            border-color: var(--gj-color-blue);

            &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 18px;
                height: 18px;
                border-radius: 50%;
                background-color: var(--gj-color-blue);
            }
        }
    }
    label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        line-height: 130%;
        gap: 2px;
        color: var(--gj-text-color);
        font-size: 14px;
        font-weight: 600;
        line-height: 130%;
        flex: 1 1 auto;

        .coupon-title {
            font-size: 14px;
            font-weight: 600;
            line-height: 130%;
            margin-bottom: 8px;
            overflow-wrap: anywhere;
        }
        .coupon-detail {
            color: var(--gj-text-color-light);
            font-size: 11px;
            font-weight: 300;
            line-height: 130%;

            &.alert {
                font-size: 10px;
                color: var(--gj-color-red);
            }
        }
        .discount-rate {
            margin-top: 12px;
            display: flex;
            flex-direction: column;
            gap: 4px;
        }
        .now-sale {
            color: var(--gj-color-pink);
            font-size: 11px;
            font-weight: 600;
            line-height: 130%;
        }
    }
}
</style>
